const invertedMessages = {
  'ID proofing': 'external.idpSetUp.isProofing',
  License: 'external.idpSetUp.license',
  'Enter License': 'external.idpSetUp.license.placeholder',
  dvcID: 'external.idpSetUp.dvcID',
  'Enter dvcID': 'external.idpSetUp.dvcID.placeholder',
  TenantDNS: 'external.idpSetUp.TenantDNS',
  'Enter TenantDNS': 'external.idpSetUp.TenantDNS.placeholder',
  DNS: 'external.idpSetUp.DNS',
  'Enter DNS': 'external.idpSetUp.DNS.placeholder',
  'Invalid input': 'external.idpSetUp.invalidInput',
  'Please enter valid input.': 'external.idpSetUp.errorMsg',
  'Community Name': 'external.idpSetUp.communityName',
  'Enter Community Name': 'external.idpSetUp.communityName.placeholder',
  Back: 'external.idpSetUp.back',
  Save: 'external.idpSetUp.save',
};

export default invertedMessages;
